/* eslint-disable max-len */
import { Component } from 'react';
import $ from 'jquery';

class VideoContainer extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);

    const element = document.getElementById('about-container');
    const width = element.offsetWidth;


    const vid = $('#video');
    const height = (width / 16) * 9;

    vid.css('height', height);
  }

  render() {
    const ldJson = {
      '@context': 'http://schema.org',
      '@type': 'VideoObject',
      'name': 'Duizenden euro\'s te veel betaald door risico-opslag',
      'description': 'Honderdduizenden huizenbezitters betalen mogelijk duizenden euro\'s te veel hypotheekrente. De meeste banken verlagen namelijk niet automatisch de risico-opslag. Ook niet als het risico voor de bank afneemt.',
      'thumbnailUrl': 'https://i.vimeocdn.com/video/669738530-be04e03032e6449ae128bc748a198f10e24925634522f9ba9a97443887ea53a2-d_640',
      'uploadDate': '2017-11-20T00:00:00Z',
      'contentUrl': 'https://player.vimeo.com/video/245143887',
      'embedUrl': 'https://player.vimeo.com/video/245143887',
    };

    return (
      <>
        <div className="about-container__background">
          <div className="about-container row" id="about-container">

            <h1>Looptijdrente live op tv</h1>
            <iframe
              sandbox="allow-scripts allow-same-origin"
              src="https://player.vimeo.com/video/245143887"
              width="100%"
              frameBorder="0"
              allowFullScreen
              id="video"
            />
            <p>
              In de uitzending van Radar, AVROTROS, van maandag 20 november 2017 heeft Jeroen Oversteegen, Directeur
              van de Nationale Hypotheekbond vragen beantwoord over hoe banken omgaan met risico opslagen. Daarbij heeft
              hij voor informatie ook verwezen naar website www.looptijdrente.nl en het belang van looptijdrente voor
              consumenten.
            </p>

            <p>
              <span className="bold">Looptijdrente</span><br/>
              De looptijdrente is de rente gedurende de gehele looptijd van de hypotheek waarbij de renteopslag
              automatisch vervalt als er voldoende is afgelost. Zodra de hypotheeklening door aflossen in een lagere
              risicoklasse valt, verlaagt de geldverstrekker automatisch de hypotheekrente. De aflossing kan maandelijks
              plaatsvinden, eventueel in combinatie met een extra bedrag. We nemen daarbij dus alleen die aanbieders en
              producten mee die dit pro actief en automatisch doen zonder dat de klant dat zelf in de gaten hoeft te
              houden of daarvoor zelf in actie hoeft te komen en / of extra kosten hoeft te betalen.
            </p>

            <p>
              <span className="bold">Uitzending bekijken</span><br/>
              <a
                href="https://radar.avrotros.nl/uitzendingen/gemist/20-11-2017/duizenden-euros-te-veel-betaald-door-risico-opslag/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Bekijk de uitzending
              </a>
            </p>
          </div>
        </div>
        <script type="application/ld+json">
          {JSON.stringify(ldJson)}
        </script>
      </>
    );
  }
}

export default VideoContainer;
